import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col gap-2',
    title: 'heading-s font-[450]',
    content: 'heading-s'
  }
});
